import React from 'react';
import toast from 'react-hot-toast';
import JobGuarantee from './TCFormats/JobGuarantee';
import TrainingOnly from './TCFormats/TrainingOnly';
import Bootcamp from './TCFormats/Bootcamp';
import JobAssistance from './TCFormats/JobAssistance';
import InterviewGuarantee from './TCFormats/InterviewGuarantee';
import PlacementTraining from './TCFormats/PlacementTraining';

const PrivacyPolicyModal = ({
  isOpen,
  onClose,
  onAccept,
  isLoading,
  termsAndConditionType,
}) => {
  if (!isOpen) return null;

  const renderContent = () => {
    switch (termsAndConditionType) {
      case 'Job Guarantee Training':
        return <JobGuarantee />;
      case 'Training only':
        return <TrainingOnly />;
      case 'Bootcamp Training Program':
        return <Bootcamp />;
      case 'Job Assistance Program':
        return <JobAssistance />;
      case 'Interview Guarantee Program':
        return <InterviewGuarantee />;
      case '100% Placement Training Program':
        return <PlacementTraining />;
      default:
        return <JobGuarantee />;
    }
  };

  return (
    <div className="bg-slate-900/60 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-md">
      <div className="max-h-[85vh] w-full max-w-4xl overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-navy-800">
        <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-700">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Students Agreement
          </h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Dear Student, Welcome to Awdiz! Your Trusted Learning Partner.
            Thanks for choosing us!!
          </p>
        </div>

        <div className="space-y-6 px-6 py-4 text-gray-600 dark:text-gray-300">
          {renderContent()}
        </div>

        <div className="flex justify-end gap-3 border-t border-gray-200 bg-gray-50 px-6 py-4 dark:border-gray-700 dark:bg-gray-700/30">
          <button
            onClick={() => {
              onClose();
              toast.error('You must accept the terms and conditions to continue');
            }}
            className="rounded-xl bg-gray-200 px-4 py-2 text-sm font-medium text-gray-800 transition-colors hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="rounded-xl bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-all hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg className="mr-2 h-4 w-4 animate-spin" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Processing...
              </span>
            ) : (
              'Accept and Continue'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
